import * as z from "zod";

export const deleteShipmonkIntegration = {
  name: "deleteShipmonkIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
